import React, { useState, useEffect } from 'react';
import {
  Typography,
  Form,
  notification,
  Input,
  Space,
  Select,
  Alert,
  Skeleton,
  Layout,
  Card,
  Descriptions,
} from 'antd';

import CustomButton from '../../../components/CustomButton';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import BreadcrumbContainer from '../../../containers/Breadcrumb';

import { get as getResume } from '../../../api/module/contractor';
import {
  put,
  get,
  announcementInfo,
} from '../../../api/module/announcement_selection';
import RestrictiveListTable from '../../../components/RestrictiveListTable';
import { useParams } from 'react-router-dom';

const { Title } = Typography;
const { TextArea } = Input;
const { Content } = Layout;

const optionSelection = [
  { id: 24, nombre: 'Pendiente' },
  { id: 25, nombre: 'Cumple' },
  { id: 26, nombre: 'No cumple' },
];

const AnnouncementSelectionValidationRestrictive = ({ history }) => {
  const { announcement_id, announcement_rol_id, selection_id, person_id } =
    useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);
  const [initialValues, setInitialValues] = useState(null);
  const [name, setName] = useState('');

  const breadcrumbItems = [
    {
      text: 'Selección',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION}`,
    },
    {
      text: 'Validación',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
    },
    {
      text: 'Validación listas restrictivas',
    },
  ];

  const back = () => {
    history.push(
      `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
    );
  };

  const onFinish = async (data) => {
    try {
      setLoading(true);

      initialValues.observacion_general_lista_restrictiva =
        data.observacion_general_lista_restrictiva;
      initialValues.estado_lista_restrictiva = data.estado_lista_restrictiva;

      const response = await put(selection_id, initialValues);

      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(
            `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
          );
          setLoading(false);
        }, MESSAGES.TIME);
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getName();
    getDataSource();
    getSelection();
  }, []);

  const getSelection = async () => {
    try {
      const response = await get(selection_id);
      setInitialValues(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getName = async () => {
    const response = await getResume(person_id);
    setName(
      `${response.data.numero_identificacion} - ${response.data.nombre_completo}`,
    );
  };

  const getDataSource = async () => {
    try {
      const { data: aData } = await announcementInfo(announcement_rol_id);
      const responsePerson = await getResume(person_id);

      aData.nombre_completo = responsePerson.data.nombre_completo;
      aData.tipo_identificacion_nombre =
        responsePerson.data.tipo_identificacion_nombre;
      aData.numero_identificacion = responsePerson.data.numero_identificacion;
      setInfo(aData);
      setLoadingForm(false);
    } catch (err) {
      console.log(err);
    }
  };

  const tailLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Módulo de Selección
      </Title>
      <Skeleton loading={loadingForm} active>
        {!!info ? (
          <Card
            size={'small'}
            bordered={false}
            title={<Title level={3}>Validación de listas restrictivas</Title>}
          >
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Número de convocatoria">
                {info.convocatoria_numero}
              </Descriptions.Item>
              <Descriptions.Item label="Cargo / Rol">
                {info.cargo}
              </Descriptions.Item>
              <Descriptions.Item label="Nombre del preseleccionado">
                {info.nombre_completo}
              </Descriptions.Item>
              <Descriptions.Item label="Tipo y número de documento del preseleccionado">
                {info.tipo_identificacion_nombre} - {info.numero_identificacion}
              </Descriptions.Item>
            </Descriptions>
            <RestrictiveListTable tercero={person_id} />
          </Card>
        ) : null}

        {initialValues != null && initialValues.cargo_aplicado !== null && (
          <Alert
            style={{ marginBottom: 10 }}
            message="Atención"
            description={`El usuario también se encuentra aplicando al cargo ${initialValues.cargo_aplicado} de esta convocatoria.
            ¿Desea continuar con el proceso para este cargo?. En caso que no continúe, por favor rechazarlo.`}
            type="error"
            showIcon
          />
        )}
        {initialValues && (
          <Card size={'small'} bordered={false}>
            <Form
              onFinish={onFinish}
              initialValues={initialValues}
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item
                name="estado_lista_restrictiva"
                label="Selección"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select disabled={initialValues.estado_seleccion === 21}>
                  {optionSelection.map((item) => (
                    <Select.Option value={item.id}>{item.nombre}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                {...tailLayout}
                name="observacion_general_lista_restrictiva"
                label="Observaciones generales listas restrictivas"
              >
                <TextArea
                  disabled={initialValues.estado_seleccion === 21}
                  rows={4}
                />
              </Form.Item>
              <Space>
                {initialValues.estado_seleccion !== 21 && (
                  <CustomButton loading={loading} text="Guardar" />
                )}
                <CustomButton
                  type={'default'}
                  className={'back-button'}
                  htmlType="button"
                  onClick={back}
                  text="Volver"
                />
              </Space>
            </Form>
          </Card>
        )}
      </Skeleton>
    </Content>
  );
};

export default AnnouncementSelectionValidationRestrictive;
